import React from "react";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";

interface PreviewModalProps {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    previewData: any;
}

const PreviewModal: React.FC<PreviewModalProps> = ({
    isOpen,
    onOpenChange,
    previewData
}) => {
    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-2xl">
                <DialogHeader>
                    <DialogTitle>Prévisualisation</DialogTitle>
                    <DialogDescription>
                        Vérifiez l'audience et le contenu de l'email avant de créer.
                    </DialogDescription>
                </DialogHeader>
                <div className="space-y-6 py-4">
                    <div className="bg-primary/5 border border-primary/10 rounded-2xl p-4 flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="h-10 w-10 bg-primary text-white rounded-xl flex items-center justify-center font-bold">
                                {previewData?.student_count}
                            </div>
                            <div>
                                <p className="text-sm font-bold text-slate-900">Étudiants ciblés</p>
                                <p className="text-xs text-slate-500">Basé sur vos formations et filtres configurés.</p>
                            </div>
                        </div>
                    </div>

                    {previewData?.sample_email ? (
                        <div className="space-y-3">
                            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">Exemple d'email rendu</p>
                            <div className="border border-slate-200 rounded-2xl overflow-hidden bg-white">
                                <div className="bg-slate-50 p-3 border-b border-slate-100">
                                    <p className="text-xs font-semibold text-slate-500 flex items-center gap-2">
                                        <span className="text-slate-400">Objet :</span> {previewData.sample_email.subject}
                                    </p>
                                </div>
                                <div
                                    className="p-6 bg-white min-h-[150px] text-sm text-slate-700 font-sans leading-relaxed email-preview-content"
                                    dangerouslySetInnerHTML={{ __html: previewData.sample_email.body }}
                                />
                            </div>
                            <p className="text-[10px] text-slate-400">Note: Les variables `{"{{prenom}}"}` etc. ont été remplacées par un exemple réel.</p>
                        </div>
                    ) : (
                        <div className="py-8 text-center bg-slate-50 rounded-2xl border border-dashed border-slate-200">
                            <p className="text-sm text-slate-400 italic">Configurez un email pour voir un aperçu.</p>
                        </div>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default PreviewModal;
